<template>
  <form-field-input
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
    type="number"
  ></form-field-input>
</template>

<script>
export default {
  name: "FilterSqft",
  props: {
    label: {
      type: String,
      default: "Sq Ft"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].sqft;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "sqft",
          value
        ]);
      }
    },
    text() {
      return (this.filterValue)
        ? `Sq Ft: ${this.filterValue}`
        : null
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
